// Un solo punto per l'indirizzo del backend: web e PWA aperte dallo stesso dominio parlano SEMPRE con lo stesso server (e DB).
// Se l'app è servita da un dominio diverso da quello compilato in REACT_APP_BACKEND_URL (es. PWA installata dal dominio
// pubblicato ma build con l'indirizzo di anteprima), si usa il dominio corrente: il backend è sempre dietro /api sulla stessa origine.
function risolviBackend() {
  const env = process.env.REACT_APP_BACKEND_URL || "";
  const qui = window.location;
  const isLocal = /^(localhost|127\.0\.0\.1)/.test(qui.hostname);
  try {
    const envHost = new URL(env).host;
    if (!isLocal && envHost && envHost !== qui.host && qui.protocol.startsWith("http")) {
      console.info(`[POSTA AI] backend: uso ${qui.origin} (build: ${envHost})`);
      return qui.origin;
    }
  } catch {
    if (!isLocal && qui.protocol.startsWith("http")) return qui.origin;
  }
  return env;
}

export const BACKEND_URL = risolviBackend();
export const API_URL = BACKEND_URL + "/api";
export const BACKEND_HOST = (() => {
  try {
    return new URL(BACKEND_URL).host;
  } catch {
    return window.location.host;
  }
})();
